import * as React from 'react';

import { ZodError, z } from 'zod';

import { useSafeContext } from '../utils/use-safe-context';

const featureAppContentSchema = z.object({
	gmcBundleId: z.string().nonempty('GMC bundle id is required'),
	gmcBundleVersion: z.string().nonempty('GMC bundle version is required'),
	gmcBundleIdOptionB: z.string().optional(),
	gmcBundleVersionOptionB: z.string().optional(),
	sortColors: z.string().optional(),
	sortRims: z.string().optional(),
	sortTrims: z.string().optional(),
	sortInteriors: z.string().optional(),
	excludeColors: z.string().optional(),
	excludeRims: z.string().optional(),
	excludeTrims: z.string().optional(),
	excludeInteriors: z.string().optional(),
	excludeColorsByTrim: z.string().optional(),
	excludeRimsByTrim: z.string().optional()
});

export type FeatureAppConfig = z.infer<typeof featureAppContentSchema>;

// @TODO add validation of the incoming data with zod schema
export const FeatureAppContentContext = React.createContext<FeatureAppConfig | undefined>(undefined);

export function useFeatureAppContent(): FeatureAppConfig {
	return useSafeContext(FeatureAppContentContext, 'FeatureAppContent');
}

export function validateFeatureAppContent(data: unknown): FeatureAppConfig {
	try {
		return featureAppContentSchema.parse(data);
	} catch (e) {
		let messages = '';
		if (e instanceof ZodError) {
			for (const issue of e.issues) {
				messages += ` ${issue.message}`;
			}
		}

		throw new Error(`Failed to validate feature app content: ${messages}`);
	}
}
